import ContentsTypes from "@shared/enums/contentsTypes";
import StatCardPreview from "@project/components/StatCard/StatCardPreview";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const StatCard = {
    label: "Statistique",
    key: "items",
    type: ContentsCustomTypes.STAT_CARD,
    Preview: StatCardPreview,
    editionModal: true,
    icon: "chart-bar",
    editionModalPosition: "top",
    children: [
        {
            label: "Statistique",
            key: "stat",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Couleur de la statistique",
            key: "statColor",
            type: ContentsTypes.COLOR,
            value: "#0CFFC6",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.SHORT_TEXT,
            value: "",
        },
    ],
};
